import { DialogClose, DialogContent, DialogFooter } from '@/components/atoms/Dialog';
import { Button } from '@/components/ui/button';

interface Props {
  content: React.ReactNode;
}

export const TermsDialogContent = ({ content }: Props) => {
  return (
    <DialogContent noCloseBtn className=" overflow-auto scrollbar-hide">
      <div className="max-h-[534px] overflow-auto">{content}</div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="SolidLow" height="44" className="">
            확인
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};
